/**
 * Identifies which scene a BatchedMesh set belongs to.
 * Used to derive mesh names and configure scene-specific options.
 */
export enum BatchedMeshTarget {
    MainScene = 'ArticleBatch',
    NavigatorScene = 'NavigatorBatch'
}
